import {
  convertEvaluationType,
  convertPropertyType,
  convertPropertyUse,
} from '../../../../api/enumerations';
import { convertPreFlightSource } from '../../../../api/preFlight/enumerations';
import { PreFlightListData } from '../../../../api/preFlight/types';
import { Constants } from '../../constants';
import {
  ClientName,
  DetailRow,
  ItemWrapper,
  OsNumber,
  OsRow,
  StatusBadge,
} from './styles';

interface RequestCardProps {
  request: PreFlightListData;
  isSelected: boolean;
  onClick: () => void;
}

export function RequestCard({
  request,
  isSelected,
  onClick,
}: RequestCardProps): JSX.Element {
  const wo = request.work_order;

  return (
    <ItemWrapper isSelected={isSelected} onClick={onClick}>
      <OsRow>
        <OsNumber>
          {Constants.osPrefix} {wo?.reference_number ?? '—'}
        </OsNumber>
        <StatusBadge status={request.status}>
          {Constants.statusLabels[request.status]}
        </StatusBadge>
      </OsRow>
      <ClientName>{request.requester_name ?? '—'}</ClientName>
      <DetailRow>
        <span>{Constants.sourceLabel}</span>{' '}
        {convertPreFlightSource(request.source)}
      </DetailRow>
      <DetailRow>
        <span>{Constants.propertyTypeLabel}</span>{' '}
        {wo.real_estate_kind != null
          ? convertPropertyType(wo.real_estate_kind)
          : '—'}
      </DetailRow>
      <DetailRow>
        <span>{Constants.propertyUseLabel}</span>{' '}
        {wo.use != null ? convertPropertyUse(wo.use) : '—'}
      </DetailRow>
      <DetailRow>
        <span>{Constants.calculationTypeLabel}</span>{' '}
        {wo.evaluation_type != null
          ? convertEvaluationType(wo.evaluation_type)
          : '—'}
      </DetailRow>
      <DetailRow>
        <span>{Constants.addressCardLabel}</span> {wo.address_summary || '—'}
      </DetailRow>
    </ItemWrapper>
  );
}
